import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { DraggableProvider } from "./context/DrabbleContext";
import firebase from "./firebase";
// import "rsuite/dist/rsuite.min.css";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <DraggableProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </DraggableProvider>
  </Provider>
);
